import './SolutionsAIAgent.css'
import Pagination from '../Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const SolutionsAIAgent = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesAIAgent = [
    {
      id: 1,
      title: t('solutionsAIAgent_page.cases.items.hub.title'),
      description: t('solutionsAIAgent_page.cases.items.hub.description'),
      icon: '',
      url: 'hub-de-ia',
    },
    {
      id: 2,
      title: t('solutionsAIAgent_page.cases.items.orderReader.title'),
      description: t('solutionsAIAgent_page.cases.items.orderReader.description'),
      icon: '',
      url: 'leitor-de-pedidos',
    },
    {
      id: 3,
      title: t('solutionsAIAgent_page.cases.items.maintenanceAssistant.title'),
      description: t(
        'solutionsAIAgent_page.cases.items.maintenanceAssistant.description',
      ),
      icon: '',
      url: 'ia-assistente-de-manutencao',
    },
    {
      id: 4,
      title: t('solutionsAIAgent_page.cases.items.hrAssistant.title'),
      description: t('solutionsAIAgent_page.cases.items.hrAssistant.description'),
      icon: '',
      url: 'ia-assistente-rh',
    },
    {
      id: 5,
      title: t('solutionsAIAgent_page.cases.items.customerInsights.title'),
      description: t('solutionsAIAgent_page.cases.items.customerInsights.description'),
      icon: '',
      url: 'customer-insights',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsAIAgent_page.cases.cta')
    trackCtaClick({
      cta_name: 'solutions_related_case_click',
      cta_location: 'solutions_ai_agent',
      page_name: 'solutions_ai_agent',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container solutions-ai solutions-ai-agent">
      <header className="main-container-top">
        <div className="text">
          <h1>{t('solutionsAIAgent_page.title')}</h1>
          <p>{t('solutionsAIAgent_page.subtitle1')}</p>
          <p>{t('solutionsAIAgent_page.subtitle2')}</p>
        </div>
        <div className="image-container">
          <img
            src="/assets/SolutionsPage/ai agent.png"
            alt={t('solutionsAIAgent_page.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('solutionsAIAgent_page.main.title')}</h2>
          <p>{t('solutionsAIAgent_page.main.p1')}</p>
          <p>{t('solutionsAIAgent_page.main.p2')}</p>

          <img
            className="AIDiagram"
            src={t('solutionsAIAgent_page.main.diagramImage')}
            alt={t('solutionsAIAgent_page.main.diagramAlt')}
          />

          <p>{t('solutionsAIAgent_page.main.p3')}</p>
          <p>{t('solutionsAIAgent_page.main.p4')}</p>
          <p>{t('solutionsAIAgent_page.main.p5')}</p>
          <ul>
            <li>{t('solutionsAIAgent_page.main.list.item1')}</li>
            <li>{t('solutionsAIAgent_page.main.list.item2')}</li>
            <li>{t('solutionsAIAgent_page.main.list.item3')}</li>
            <li>{t('solutionsAIAgent_page.main.list.item4')}</li>
            <li>{t('solutionsAIAgent_page.main.list.item5')}</li>
          </ul>
          <p>{t('solutionsAIAgent_page.main.p6')}</p>
        </div>
        <div className="main-content-secondary">
          <div className="AIAgent">
            <div className="AIContent">
              <div className="AIMainSection">
                <div className="AICardsAndDiagram">
                  <div className="AICards">
                    <div className="AICard cxax">
                      <h3>
                        {t('solutionsAIAgent_page.cards.cxax.title')}
                        <img
                          src="/assets/Home/cxax.png"
                          alt={t('solutionsAIAgent_page.cards.cxax.iconAlt')}
                        />
                      </h3>
                      <p>{t('solutionsAIAgent_page.cards.cxax.description')}</p>
                    </div>
                    <div className="AICard business">
                      <h3>
                        {t('solutionsAIAgent_page.cards.business.title')}
                        <img
                          src="/assets/Home/business.png"
                          alt={t('solutionsAIAgent_page.cards.business.iconAlt')}
                        />
                      </h3>
                      <p>{t('solutionsAIAgent_page.cards.business.description')}</p>
                    </div>
                    <div className="AICard digital">
                      <h3>
                        {t('solutionsAIAgent_page.cards.digital.title')}
                        <img
                          src="/assets/Home/digital.png"
                          alt={t('solutionsAIAgent_page.cards.digital.iconAlt')}
                        />
                      </h3>
                      <p>{t('solutionsAIAgent_page.cards.digital.description')}</p>
                    </div>
                    <div className="AICard analytics">
                      <h3>
                        {t('solutionsAIAgent_page.cards.analytics.titleLine1')}
                        <br /> {t('solutionsAIAgent_page.cards.analytics.titleLine2')}
                        <img
                          src="/assets/Home/data.png"
                          alt={t('solutionsAIAgent_page.cards.analytics.iconAlt')}
                        />
                      </h3>
                      <p>{t('solutionsAIAgent_page.cards.analytics.description')}</p>
                    </div>
                  </div>
                  <div className="Diagram">
                    <img
                      src={t('home_page.aiAgent.diagramImage')}
                      alt={t('solutionsAIAgent_page.cards.diagramAlt')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="main-cases-container solutions-ai">
        <h2 className="title">{t('solutionsAIAgent_page.cases.title')}</h2>
        <p className="subtitle">{t('solutionsAIAgent_page.cases.subtitle')}</p>

        <Pagination data={casesAIAgent} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="case-icon">{caseItem.icon}</span>
                  <h3>{caseItem.title}</h3>
                  <p>{caseItem.description}</p>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault()
                      handleRelatedCaseCtaClick(caseItem)
                    }}
                  >
                    {t('solutionsAIAgent_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default SolutionsAIAgent
